module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<!-- page / thumbnail item -->\r\n")
    ; 
    var _ = require('lodash');
    var ls = require('ListService.js').default;
    var constants = require('Constants.js').default;
    var marginLeff= 'padding-left: 10px;';
    var objs = objects.reverse();
    var util = require('util/Util').default;

    if ( !constants.HAS_THUMBNAILS ) {

    /*
     * For click-to-change displayed page:
     * The clicked element must have:
     *  id="pgref-< %- seq % >"
     *  class="tn-target"
     *  data-page="< %= id % >"
    */

    ; __append("\r\n\r\n\r\n<div id=\"tn-pg-")
    ; __append(escapeFn( id))
    ; __append("\" class=\"document\">\r\n    <div class=\"document-heading\" style=\"display: flex; flex-wrap: nowrap; display: -ms-flex; -ms-flex-wrap: -ms-nowrap;\">\r\n        <i class=\"fa pf-drag draggable\"></i>\r\n        <h4 class=\"document-title tn-target\" id=\"pgref-")
    ; __append( seq )
    ; __append("\" data-page=\"")
    ; __append(escapeFn( id ))
    ; __append("\" style=\"height: auto;padding-top: 6px; margin: 0; width: 100%; text-overflow: ellipsis;\" title=\"")
    ; __append(escapeFn( pageTitle))
    ; __append("\">\r\n            <a role=\"button\">")
    ; __append(escapeFn(pageTitle))
    ; __append("</a>\r\n        </h4>\r\n\r\n        <div style=\"width: 20px;\">\r\n            ")
    ;  if (hasTwoColumnsIcon) { 
    ; __append("\r\n                <div title=\"Two column configuration\">\r\n                    <svg viewBox=\"0 0 576 512\" class=\"twoColumnsIcon\" xmlns=\"http://www.w3.org/2000/svg\" id=\"wizard-twoColumns-PFXX6518860314828603393\">\r\n                        <path fill=\"currentColor\" d=\"")
    ; __append(escapeFn(constants.TWO_COLUMNS_ICON))
    ; __append("\"/>\r\n                    </svg>\r\n                </div>\r\n            ")
    ;  }

            if (hasEyeIcon) { 
    ; __append("\r\n                <div title=\"Hidden\" class=\"eyeIcon\">\r\n                   <svg viewBox=\"0 0 576 512\" class=\"sc-EHOje eyeIcon\" xmlns=\"http://www.w3.org/2000/svg\">\r\n                      <path fill=\"currentColor\" d=\"")
    ; __append(escapeFn(constants.EYE_CONTENT_ICON))
    ; __append("\"/>\r\n                   </svg>\r\n                </div>\r\n            ")
    ;  } 
    ; __append("\r\n        </div>\r\n\r\n        <a role=\"button\" data-toggle=\"collapse\" data-target=\"#well")
    ; __append(escapeFn( id))
    ; __append("\" class=\"switch collapsed\">\r\n            <i class=\"fa pf-carot-left\"></i>\r\n        </a>\r\n    </div>\r\n    <div id=\"well")
    ; __append(escapeFn( id))
    ; __append("\" class=\"document-body collapse\">\r\n        <div class=\"document-items\">\r\n            <div id=\"objects-page-")
    ; __append(escapeFn( id))
    ; __append("\" class=\"bo-body objects\">\r\n                <ul class=\"behavior-options\" data-page-id=\"")
    ; __append(escapeFn(id))
    ; __append("\">\r\n                </ul>\r\n\r\n                <ul class=\"column-options\" data-page-id=\"")
    ; __append(escapeFn(id))
    ; __append("\">\r\n                    <li id=\"")
    ; __append(escapeFn(id))
    ; __append("-mobile-column1\" class=\"object-selector\" style=\"white-space: normal\" data-id=\"mobile-column1\" data-parentid=\"tn-pg-")
    ; __append(escapeFn(id))
    ; __append("\">\r\n                        <a class=\"switch\" data-toggle=\"collapse\" data-target=\"#section-container-1-")
    ; __append(escapeFn( id))
    ; __append("\">\r\n                            <i style=\"margin-left:5px\" role=\"button\" class=\"fa pf-carot-left pf-rotate-icon\">\r\n                            </i>\r\n                            <span class=\"control-name-selector\">Column 1</span>\r\n                        </a>\r\n\r\n                        <div id=\"section-container-1-")
    ; __append(escapeFn( id))
    ; __append("\" class=\"collapse\">\r\n                            <ul class=\"section-options-1\" data-page-id=\"")
    ; __append(escapeFn( id))
    ; __append("\">\r\n                            </ul>\r\n                        </div>\r\n                    </li>\r\n\r\n\r\n                    <li id=\"")
    ; __append(escapeFn(id))
    ; __append("-mobile-column2\" class=\"object-selector\" style=\"white-space: normal\" data-id=\"mobile-column2\"  data-parentid=\"tn-pg-")
    ; __append(escapeFn(id))
    ; __append("\">\r\n                        <a class=\"switch\" data-toggle=\"collapse\" data-target=\"#section-container-2-")
    ; __append(escapeFn(id))
    ; __append("\">\r\n                            <i style=\"margin-left:5px\" role=\"button\" class=\"fa pf-carot-left pf-rotate-icon\">\r\n                            </i>\r\n                            <span class=\"control-name-selector\">Column 2</span>\r\n                        </a>\r\n\r\n                        <div id=\"section-container-2-")
    ; __append(escapeFn( id))
    ; __append("\" class=\"collapse\">\r\n                            <ul class=\"section-options-2\" data-page-id=\"")
    ; __append(escapeFn( id))
    ; __append("\">\r\n                            </ul>\r\n                        </div>\r\n                    </li>\r\n                </ul>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n")
    ;  } else { 
    ; __append("\r\n\r\n<div id=\"tn-pg-")
    ; __append( pageNumber)
    ; __append("\">\r\n\r\n    <div class=\"thumbnail-page-tile\">")
    ; __append(escapeFn(pageTitle))
    ; __append("</div>\r\n    <div id=\"pgref-")
    ; __append( seq )
    ; __append("\" data-page=\"")
    ; __append(escapeFn( id ))
    ; __append("\" class=\"tn-target\"\r\n         style=\"height: 100px; width: 200px; display: block; background-color: #e2e2e2;\">\r\n        <!-- Generated thumbnail canvas inserts here -->\r\n    </div>\r\n\r\n    <div data-toggle=\"collapse\" data-target=\"#Page")
    ; __append(id)
    ; __append("-Behavior\"\r\n         class=\"object-list-header pf-short-button\">")
    ; __append(behaviorCount)
    ; __append(" Behaviors</div>\r\n    <div id=\"Page")
    ; __append(id)
    ; __append("-Behavior\" class=\"collapse\">\r\n        <ul id=\"Page")
    ; __append(id)
    ; __append("BehaviorList\" data-role=\"listview\">\r\n\r\n            ")
    ;  _.forEach( behaviors, function(obj) { 
    ; __append("\r\n            <li data-object-id=\"")
    ; __append(escapeFn(obj.id))
    ; __append("\" >\r\n                <a>")
    ; __append( obj.name )
    ; __append("</a>\r\n            </li>\r\n            ")
    ;  }); 
    ; __append("\r\n\r\n        </ul>\r\n    </div>\r\n\r\n    <div data-toggle=\"collapse\" data-target=\"#Page")
    ; __append(id)
    ; __append("-Object\"\r\n         class=\"object-list-header pf-short-button\">")
    ; __append(objectCount)
    ; __append(" Objects</div>\r\n    <div id=\"Page")
    ; __append(id)
    ; __append("-Object\" class=\"collapse\">\r\n        <ul id=\"Page")
    ; __append(id)
    ; __append("ObjectList\" data-role=\"listview\">\r\n\r\n            ")
    ;  _.forEach( objs, function(obj) { 
    ; __append("\r\n            <li data-object-id=\"")
    ; __append(escapeFn(obj.id))
    ; __append("\" >\r\n                <a>")
    ; __append( obj.name )
    ; __append("</a>\r\n            </li>\r\n            ")
    ;  }); 
    ; __append("\r\n\r\n        </ul>\r\n    </div>\r\n</div>\r\n\r\n")
    ;  } 
    ; __append("\r\n")
  }
  return __output;

}